import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { PermissionGroupsService } from "../Services/PermissionGroups.service";
import { PERMISSION_GROUPS_QUERY_KEY } from "../constants";

export function useDeletePermissionGroup() {
  const {
    mutate: deletePermissionGroup,
    isLoading: isDeleting,
    isSuccess: isDeleted,
    isError: isDeleteFailed,
    variables,
  } = useMutation({
    mutationFn: async (permissionGroupId: string) => {
      return await PermissionGroupsService.deletePermissionGroup(
        permissionGroupId
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    options: {
      queryKey: PERMISSION_GROUPS_QUERY_KEY,
    },
    onSuccess: (c) => {},
  });

  return {
    deletePermissionGroup,
    isDeleting,
    isDeleted,
    isDeleteFailed,
    variables,
  };
}
